// removed by extract-text-webpack-plugin
module.exports = {"mono":"InputValueEditor__mono___2yzd3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputValueEditor/InputValueEditor.css
// module id = 962
// module chunks = 0